import { obterCompartimentoAsync, obterCompartimentoPorPlanoAsync } from "../../services/compartimentoService";

const atualizarCompartimentos = async ({ commit }) => {
    const compartimentos = await obterCompartimentoAsync();
    commit('atualizarCompartimentos', compartimentos);
}

const atualizarCompartimentoPorPlano = async ({ commit }, idPlano) => {
    const compartimentoPlanos = await obterCompartimentoPorPlanoAsync(idPlano);
    commit('atualizarCompartimentoPorPlano', compartimentoPlanos);
}

const atualizarCompartimento = ({ commit }, compartimento) => {
    commit('atualizarCompartimento', compartimento);
}

const updateCompartimento = ({ commit }, compartimento) => {
    commit('updateCompartimento', compartimento);
}

export default {
    atualizarCompartimentos,
    atualizarCompartimento,
    atualizarCompartimentoPorPlano,
    updateCompartimento
}